module.exports = __webpack_public_path__ + "static/img/Charlie_Cameron_mobile.d89812e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie_Cameron_mobile.jpg
// module id = r2IR
// module chunks = 0